// CSS Modules - component class name: FormInput__

<template>
  <div
    :class="[
      $style.container,
      { FormInput__error: this.error },
      { FormInput__original: this.showOriginalValueState }
    ]"
  >
    <label :class="[$style.label, { FormInput__bold: this.boldLabel }]">
      {{ label }}
      <span :class="$style.optional" v-if="optionalLabel">
        ({{ optionalLabel }})
      </span>
    </label>
    <input
      :type="type"
      :value="value"
      :maxlength="maxlength"
      :min="min"
      :placeholder="placeholder"
      @input="handleInput"
      @focus="handleInputFocus"
      @blur="handleInputBlur"
    />
    <div v-if="error" :class="$style.errorMessage">{{ errorMessage }}</div>
  </div>
</template>

<script>
export default {
  name: "FormInput",
  props: {
    type: String,
    value: String,
    label: {
      type: String,
      default: ""
    },
    boldLabel: {
      type: Boolean,
      default: false
    },
    optionalLabel: String,
    errorMessage: {
      type: String,
      default: ""
    },
    error: {
      type: Boolean,
      default: false
    },
    originalValue: String,
    formSubmitSwitch: {
      type: Boolean,
      default: false
    },
    placeholder: String,
    maxlength: String,
    min: String
  },
  data() {
    return {
      currentValue: "",
      showOriginalValueState: false
    };
  },
  methods: {
    handleInput($event) {
      this.currentValue = $event.target.value;
      this.$emit("input", $event.target.value);
    },
    handleInputFocus() {
      if (
        this.originalValue &&
        (this.value === "" || this.value === this.originalValue)
      ) {
        this.showOriginalValueState = false;
        this.$emit("input", "");
      }
    },
    handleInputBlur() {
      if (this.originalValue && this.value === "") {
        this.showOriginalValueState = true;
        this.$emit("input", this.originalValue);
      }
    }
  },
  watch: {
    formSubmitSwitch: function(newValue, oldValue) {
      if (newValue !== oldValue && this.originalValue) {
        this.showOriginalValueState = true;
      }
    }
  }
};
</script>

<style module lang="scss">
@import "./FormInput.scss";
</style>
